module.exports = __webpack_public_path__ + "static/media/1.83152474.png";